<button mat-raised-button  *appRole="['TiposComprobante.Crear']" color="primary" [routerLink]="['/tiposcomprobante']">
  <mat-icon>add</mat-icon>
  Nuevo tipo bonificación
</button>
